import PropTypes from 'prop-types'

import {Map, List} from 'immutable'

import Tooltip from '../mui_base_components/tooltip/ToolTip'

import infoIcon from '../../shared_assets/info-icon.svg'

import './policyInfo.scss'

const PolicyInfo = ({policyInfo = List()}) => {
  const safePolicyInfo = List.isList(policyInfo) ? policyInfo : List()

  if (safePolicyInfo.isEmpty()) {
    return (
      <div
        className='policy-info processing-policy-message'
        data-testid='policy-info'>
        The policy is currently being processed. Once the policy is issued, the
        policy number will appear here. This process typically takes about two
        weeks.
      </div>
    )
  }

  const insurancePolicyInfo = safePolicyInfo.find(
    map => Map.isMap(map) && map.has('insurance')
  )?.get('insurance') || Map()

  const oapPolicyInfo = safePolicyInfo.find(
    map => Map.isMap(map) && map.has('oap')
  )?.get('oap') || Map()

  const getTooltipTitle = info => (
    <div>
      {
        info.get('phone') &&
        <div className='label'>Phone: <span>{info.get('phone')}</span></div>
      }
      {
        info.get('email') &&
        <div className='label'>Email: <span>{info.get('email')}</span></div>
      }
      {
        info.get('website') &&
        <div className='label'>Website: <span>{info.get('website')}</span></div>
      }
    </div>
  )

  const renderAdditionalInfoTooltip = info => {
    const tooltipProps = {
      slotProps: {
        popper: {
          sx: {
            '& .MuiTooltip-tooltip.MuiTooltip-tooltip': {
              fontSize: '0.8125rem',
              padding: '10px',
              textAlign: 'left'
            },
            '.label': {
              fontWeight: '600',

              span: {fontWeight: '400'}
            }
          }
        }
      }
    }

    return (
      <Tooltip title={getTooltipTitle(info)} {...tooltipProps}>
        <button
          type='button'
          className='info-button'
          aria-label='Additional info'>
          <img
            alt='Additional Info'
            className='info-icon'
            src={infoIcon}
          />
        </button>
      </Tooltip>
    )
  }

  const hasAdditionalInfo = info => ['email', 'phone', 'website'].some(key => {
    const value = info.get(key)

    return typeof value !== 'undefined' &&
      value !== null &&
      String(value).trim() !== ''
  })

  return (
    <div className='policy-info' data-testid='policy-info'>
      <div className='funeral-policy-container'>
        <h3 className='info-title'>Funeral policy</h3>
        <div className='label'>
          <span className='label__title'>Issued by:{' '}</span>
          <span className='label__value'>
            {insurancePolicyInfo.get('policy-origin')}
            {
              hasAdditionalInfo(insurancePolicyInfo) &&
              renderAdditionalInfoTooltip(insurancePolicyInfo)
            }
          </span>
        </div>
        {
          insurancePolicyInfo.get('policy-id') &&
            <div className='label'>
              <span className='label__title'>Policy number:{' '}</span>
              <span className='label__value'>
                {insurancePolicyInfo.get('policy-id')}
              </span>
            </div>
        }
      </div>

      { !oapPolicyInfo.isEmpty() && (
        <div className='oap-container'>
          <h3 className='info-title'>Out of area protection</h3>
          <div className='label'>
            <span className='label__title'>Issued by:{' '}</span>
            <span className='label__value'>
              {oapPolicyInfo.get('policy-origin')}
              {
                hasAdditionalInfo(oapPolicyInfo) &&
                renderAdditionalInfoTooltip(oapPolicyInfo)
              }
            </span>
          </div>
          {
            oapPolicyInfo.get('policy-id') &&
              <div className='label'>
                <span className='label__title'>Policy number:{' '}</span>
                <span className='label__value'>
                  {oapPolicyInfo.get('policy-id')}
                </span>
              </div>
          }
        </div>
      )}
    </div>
  )
}

PolicyInfo.propTypes = {policyInfo: PropTypes.instanceOf(List)}

export default PolicyInfo
